import React from 'react';
import SCText from '@this/components/organization/text';
import type TripReportWithoutTrip from '@this/domain/trip_report/trip_report_without_trip';
import { isTabikobo } from '@this/src/util/utils';

interface Props {
  serviceId: number;
  tripReport: TripReportWithoutTrip;
  tripReportAvailable: boolean;
}

// 旅程の行（table/item/item.tsx）と同じ列幅にそろえる
const columnWidths = (tabikobo: boolean, tripReportAvailable: boolean): string[] => [
  tripReportAvailable ? '7.5%' : '8%',
  tabikobo ? '7%' : '0%',
  tabikobo ? '13%' : '15%',
  tabikobo ? '18%' : '23%',
  tripReportAvailable ? '9%' : '12%',
  tripReportAvailable ? '7.5%' : '12%',
  tripReportAvailable ? '7.5%' : '0%',
  '8%',
  '16%',
  '6%'
];

const smallStyle: React.CSSProperties = {
  display: 'block',
  fontWeight: 'normal',
  fontSize: '10px',
  marginTop: '4px'
};

// 報告番号検索で、どの旅程にも紐づかない出張報告を1行で表示する。
// 旅程がないため、旅程詳細の「開く」ボタンは置かず、報告番号のリンクから出張報告詳細を開く。
const TripReportWithoutTripItem: React.FC<Props> = ({ serviceId, tripReport, tripReportAvailable }) => {
  const widths = columnWidths(isTabikobo(serviceId), tripReportAvailable);
  const cellStyle = (index: number): React.CSSProperties => ({
    width: widths[index],
    padding: '14px 0',
    fontWeight: 'bold'
  });

  return (
    <div data-testid="trip-report-without-trip-row">
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={cellStyle(0)} data-testid="trip-report-without-trip-trip-id">
          紐づく旅程なし
        </div>
        <div style={cellStyle(1)} />
        <div style={cellStyle(2)} data-testid="trip-report-without-trip-applicant">
          {tripReport.applicantName}
        </div>
        <div style={cellStyle(3)} />
        <div style={cellStyle(4)} />
        <div style={cellStyle(5)} />
        <div style={cellStyle(6)} data-testid="trip-report-without-trip-report-id">
          {tripReportAvailable && (
            <SCText
              serviceId={serviceId}
              type="link"
              value={String(tripReport.id)}
              to={`/trip_report/${tripReport.id}`}
            />
          )}
        </div>
        <div style={cellStyle(7)}>
          <div data-testid="trip-report-without-trip-total-price">{`${tripReport.totalPrice.toLocaleString()}円`}</div>
          <small className="text--muted" style={smallStyle} data-testid="trip-report-without-trip-status">
            {tripReport.statusName()}
          </small>
        </div>
        <div style={cellStyle(8)} />
        <div style={cellStyle(9)} />
      </div>
    </div>
  );
};

export default TripReportWithoutTripItem;
